import { Breadcrumbs, Box, Typography, Link } from '@mui/material';
import { HomeLine } from '../../assets';
import { Link as RouterLink } from 'react-router-dom';

const CustomBreadCrumbs = ({ title, children }: { title: string; children?: React.ReactNode }) => {
  return (
    <Breadcrumbs sx={{ mb: '8px' }}>
      <Link to="/"
        component={RouterLink}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <HomeLine height={'20px'}
            width={'20px'} />
        </Box>
      </Link>
      {children}
      <Typography>{title}</Typography>
    </Breadcrumbs>
  );
};

export default CustomBreadCrumbs;